import { render, staticRenderFns } from "./BulkActionsComponent.vue?vue&type=template&id=e7734326"
import script from "./BulkActionsComponent.vue?vue&type=script&lang=js"
export * from "./BulkActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports